import { PayloadAction } from "@reduxjs/toolkit";
import { StatusLoading } from 'common/constants/statusLoading';

import { IState } from "../types";

const statusLoading = (state: IState, action: PayloadAction<StatusLoading>) => {
  state.isLoading = action.payload;
};

export default statusLoading;
